const stripEnvQuotes = (value: string | undefined) =>
  (value || "").trim().replace(/^['"]|['"]$/g, "").replace(/\/+$/, "");

const getApiBaseUrl = () =>
  stripEnvQuotes(
    process.env.REACT_APP_BASE_URL || process.env.REACT_APP_API_BASE_URL
  );

export async function getActivePinCode() {
  try {
    const headers: Record<string, string> = {
      "Content-Type": "application/json",
      Accept: "application/json",
    };
    const apiKey = stripEnvQuotes(
      process.env.REACT_APP_CREATIVE_API_KEY ||
        process.env.REACT_APP_API_KEY ||
        process.env.REACT_APP_KIOSK_API_KEY
    );
    if (apiKey) {
      headers["X-API-Key"] = apiKey;
    }

    const apiBaseUrl = getApiBaseUrl();
    if (!apiBaseUrl) {
      return {
        success: false as const,
        error: "API base URL is not configured. Set REACT_APP_BASE_URL.",
      };
    }

    if (!apiKey) {
      return {
        success: false as const,
        error:
          "API key is not configured. Set REACT_APP_CREATIVE_API_KEY in .env.",
      };
    }

    const response = await fetch(`${apiBaseUrl}/admin/pin-code/public`, {
      method: "GET",
      headers,
    });

    if (!response.ok) {
      const errorText = await response.text();
      let message = errorText;
      try {
        const parsed = JSON.parse(errorText) as { message?: string };
        if (parsed?.message) message = parsed.message;
      } catch {
        /* keep raw text */
      }
      return {
        success: false as const,
        error: `Failed to fetch PIN code (${response.status}): ${message}`,
      };
    }

    const data = await response.json();
    const pinCode =
      data?.pinCode ?? data?.pin_code ?? data?.data?.pinCode ?? data?.data?.pin_code;
    if (pinCode) {
      return { success: true as const, pinCode: String(pinCode) };
    }
    return { success: false as const, error: "Invalid response format from API" };
  } catch (error) {
    return {
      success: false as const,
      error:
        error instanceof Error
          ? error.message
          : "Network error while fetching PIN code",
    };
  }
}
